module.exports = __webpack_public_path__ + "img/9.75677863.jpg";